import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { UIService, AlertService } from '../_services';
import { AuthService } from '../_services/auth.service';

const samePasswords = (form: AbstractControl): ValidationErrors | null =>
  form.value.password === form.value.confirmPassword ? null : { mismatch: true };

/** The page an emailed reset link opens: choose a new password with the link's token */
@Component({
    selector: 'app-resetpassword',
    templateUrl: './resetpassword.component.html',
    styleUrls: ['../forgotpassword/forgotpassword.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResetpasswordComponent implements OnInit, OnDestroy {
  token: string | null;
  resetForm: UntypedFormGroup;
  submitted = false;
  loading = false;
  done = false;

  logo: string;
  logoListener: Subscription;

  constructor(
    private route: ActivatedRoute,
    private uiservice: UIService,
    private authService: AuthService,
    private alert: AlertService,
    private formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit() {
    this.uiservice.setTitle('Reset Password');
    this.logoListener = this.uiservice.logoSubject.subscribe(logo => this.logo = logo);
    this.token = this.route.snapshot.queryParamMap.get('token');
    // the rules of the API (and invenire-v2)
    this.resetForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required],
    }, { validators: samePasswords });
  }

  ngOnDestroy() {
    this.logoListener.unsubscribe();
  }

  onSubmit() {
    this.submitted = true;
    if (this.resetForm.invalid) {
      return;
    }

    this.loading = true;
    const { password, confirmPassword } = this.resetForm.value;
    this.authService.confirmReset(this.token, password, confirmPassword).subscribe({
      next: ({ message }) => {
        this.loading = false;
        this.done = true;
        this.alert.success(message);
      },
      error: ({ status, error }) => {
        this.loading = false;
        // validation errors come as a list of messages
        this.alert.error(status === 400 || status === 429 ?
          [].concat(error?.message).join(' ') :
          'Something went wrong! Please try again later');
      },
    });
  }
}
